import React, { useEffect, useState } from 'react';
import { Container, Grid, CircularProgress, Box, Typography } from '@mui/material';
import { getNetworkInfoDetails } from '../action';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BarGraphSalesAnalysis from '../Component/BarGraphSalesAnalysis';
import LastTransactions from '../Component/LastTransactions';
import SalesDashboardCard from '../Component/SalesDashboardCard';

const VcpSalesDashBoard = () => {
  const location = useLocation();
  const { company_details, comapny_entity_id } = useSelector((state) => ({
    company_details: state.reportReducer.company_details,
    comapny_entity_id: state.reportReducer.comapny_entity_id,
  }));
  const company_id = location.state?.company_id;
  const selectedRole = location.state?.selectedRole
  const [networkDetail, setNetworkDetail] = useState({});
  const [isLoading, setLoading] = useState(false);

  const getNetworkInfoDetail = async () => {
    setLoading(true);
    const payload = {
      supplier_id: company_details?.id,
      company_id: company_id,
      user_company_esi_id: comapny_entity_id,
    };

    const { data, error, message } = await getNetworkInfoDetails(payload);
    if (!error) {
      setNetworkDetail(data);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (company_id && company_details?.id && comapny_entity_id ) {
      getNetworkInfoDetail();
    }
  }, [company_id, company_details?.id, comapny_entity_id]);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          pb: 10,
        }}
      >
        <Typography variant="h2" sx={{ mb: 3, fontWeight: 'bold' }}>
          Network Performance
        </Typography>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
            >
              <SalesDashboardCard
                data={networkDetail?.sale_summary_card_info}
                selectedRole = {selectedRole}
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <LastTransactions
                transactions={
                  networkDetail?.last_few_sales_transaction?.transactions
                }
                section_header_display_title={
                  networkDetail?.last_few_sales_transaction
                    ?.section_header_display_title
                }
              />
            </Grid>

            <Grid
              item
              xs={12}
            >
              <BarGraphSalesAnalysis
                analysisData={networkDetail?.month_wise_own_sales_chart}
              />
            </Grid>

            {networkDetail?.month_wise_influencer_sales_chart && (
              <Grid
                item
                xs={12}
              >
                <BarGraphSalesAnalysis
                  analysisData={
                    networkDetail?.month_wise_influencer_sales_chart
                  }
                />
              </Grid>
            )}
          </Grid>
        )}
      </Container>
    </>
  );
};

export default VcpSalesDashBoard;
